import { AllocationMonitoringDashboard } from './AllocationMonitoringDashboard';

export default function SgDashboardPage() {
  return <AllocationMonitoringDashboard variant="sg" />;
}
